import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-186856a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claiming-success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Successfully claimed", -1))
const _hoisted_3 = { class: "claiming-success__amount" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "claiming-success__amount-amount" }
const _hoisted_6 = { class: "claiming__buttons" }

import SuccessIcon from "@/icons/send/success-icon.vue";
import BaseButton from "@/components/base-button/index.vue";
import { useRouter } from "vue-router";
import { Token } from "@/types/token";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'claiming-success',
  props: {
  token: {
    type: Object as PropType<Token>,
    default: null,
  },
  amount: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const router = useRouter();



const closeAction = () => {
  router.push({ name: "main" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SuccessIcon),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "claiming-success__amount-icon",
        src: __props.token.image
      }, null, 8, _hoisted_4),
      _createElementVNode("h4", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.amount)) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.token.symbol), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(BaseButton, {
        title: "Go to accounts",
        action: closeAction
      })
    ])
  ]))
}
}

})